import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Charts from '../../common/Charts/Charts';
import { processCompetionGraphTableChartData } from '../../../util/SalesCatalystUtils';
class SalesCatalystComparisonTableGraph extends Component {
  constructor(props) {
    super(props);
    const { data } = this.props;
    this.state = {
      chartData: data !== undefined ? data : [],
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.data !== nextProps.data) {
      this.setState({
        chartData: nextProps.data,
      });
    }
  }


  render() {
    const {expandMode, data, graphType} = this.props;
    const {chartData} = this.state;
    return (
      <div>
        <div className="row">
          {data && data.length > 0 && 
            <div className="row">
              <Charts
                config={processCompetionGraphTableChartData(chartData,
                  graphType,
                  expandMode
                  )}
              />
            </div>
          }
          {data && data.length === 0 &&
            <div className="cs-graph-error-msg">No Data Available</div>
          }
        </div>
      </div>
    );
  }
}

SalesCatalystComparisonTableGraph.propTypes = {
  // loginResponse: PropTypes.shape({
  // }),
};

function mapStateToProps(state) {
  return {
    // loginResponse: state.login.loginResponse,
  };
}

export default connect(
  mapStateToProps,
  null,
  null,
)(SalesCatalystComparisonTableGraph);
